export enum ExperimentNames {
  AscendAwareness = 'specs.ascend.AscendAwareness',
}
